let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5qLt8")).then(() => parcelRequire('53F3I'));